/* eslint-disable camelcase */

import { getDefaultStatisticItem } from '../../utils/utils'

const possessionEvents = ['SAFE_ZONE', 'ATTACK', 'POSESSION_1', 'POSESSION_2']
const zonesByEventCode = {
  'SAFE_ZONE': 'defense',
  'ATTACK': 'attack',
  'POSESSION_1': 'center',
  'POSESSION_2': 'center'
}
let previousActiveSide = null
let previousPlayTime = null
let prevZone

export default {
  statisticScheme: {
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true,  editable: false }),
    possession_attack: getDefaultStatisticItem('statistic.poss.attack', { percentFrom: 'possession' }),
    possession_center: getDefaultStatisticItem('statistic.poss.center', { percentFrom: 'possession' }),
    possession_defense: getDefaultStatisticItem('statistic.poss.defense', { statisticFunction: defenseStatisticFunction.toString() }),
    'CORNER_KICK': getDefaultStatisticItem('statistic.cornerKick'),
    'CORNER_1': getDefaultStatisticItem(),
    'CORNER_2': getDefaultStatisticItem(),
    'CORNER_3': getDefaultStatisticItem(),
    'CORNER_4': getDefaultStatisticItem(),
    'RED_CARD': getDefaultStatisticItem('statistic.redCard'),
    'YELLOW_CARD': getDefaultStatisticItem('statistic.yellowCard'),
    'SECOND_YELLOW_CARD': getDefaultStatisticItem(),
    'FOUL': getDefaultStatisticItem(),
    'OFFSIDE': getDefaultStatisticItem(),
    'ZONE_GOAL_KICK': getDefaultStatisticItem('statistic.football.zone_goal_kick'),
    'DANGEROUS_ATTACK': getDefaultStatisticItem('statistic.football.dangerous_attack'),
    'MEDICAL_CREW': getDefaultStatisticItem(),
    'SHOOT_GOALPOST': getDefaultStatisticItem(),
    'GOAL_MOUTH_SHOT': getDefaultStatisticItem(),
    'THROW_IN': getDefaultStatisticItem()
  },
  statisticEvents: {
    'CORNER_KICK': 'CORNER_KICK',
    'CORNER_1': 'CORNER_1',
    'CORNER_2': 'CORNER_2',
    'CORNER_3': 'CORNER_3',
    'CORNER_4': 'CORNER_4',
    'FOUL': 'FOUL',
    'OFFSIDE': 'OFFSIDE',
    'YELLOW_CARD': 'YELLOW_CARD',
    'SECOND_YELLOW_CARD': 'SECOND_YELLOW_CARD',
    'RED_CARD': ['RED_CARD', 'SECOND_YELLOW_CARD', 'SECOND_YELLOW_CARD_SUBSTITUTION_RIGHT', 'RED_CARD_SUBSTITUTION_RIGHT'],
    'ZONE_GOAL_KICK': ['GOAL_KICK', 'ZONE_GOAL_KICK'],
    'DANGEROUS_ATTACK': 'DANGEROUS_ATTACK',
    'MEDICAL_CREW': 'MEDICAL_CREW',
    'SHOOT_GOALPOST': 'SHOOT_GOALPOST',
    'GOAL_MOUTH_SHOT': 'GOAL_MOUTH_SHOT',
    'THROW_IN': 'THROW_IN'
  },
  statisticOrder: [
    'possession',
    'possession_attack',
    'possession_center',
    'possession_defense',
    'CORNER_KICK',
    'ZONE_GOAL_KICK',
    'YELLOW_CARD',
    'SECOND_YELLOW_CARD',
    'RED_CARD',
    'DANGEROUS_ATTACK',
    'FOUL',
    'OFFSIDE',
    'MEDICAL_CREW',
    'SHOOT_GOALPOST',
    'GOAL_MOUTH_SHOT',
    'THROW_IN'
  ],
  customStatisticEvents: [
    'GOAL',
    'CORNER_KICK',
    'YELLOW_CARD',
    'SECOND_YELLOW_CARD',
    'RED_CARD',
    'PENALTY_CONFIRMED',
    'FREE_KICK',
    'DANGEROUS_FREE_KICK',
    'DANGEROUS_ATTACK',
    'ATTACK',
    'SUBSTITUTION',
    'ZONE_GOAL_KICK'
  ],
  statisticFunction (event) {
    getCommonPossessionStatistic.bind(this)(event)
    updateZone.bind(this)(event)
    adjustStatistic.bind(this)(event)
    updateFoulsForPenaltyConfirmed.bind(this)(event)
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

function updateZone (event) {
  const { EventCode } = event
  const needToChangeZone = possessionEvents.includes(EventCode)

  if (needToChangeZone) {
    prevZone = zonesByEventCode[EventCode]
  }
}

function defenseStatisticFunction (team) {
  const { statistic } = this
  const { possession, possession_attack, possession_center } = statistic
  const attack = Math.round(possession_attack[team] / possession[team] * 100)
  const center = Math.round(possession_center[team] / possession[team] * 100)
  const val = 100 - attack - center
  const value = isNaN(val) || val < 0 ? '0%' : `${val}%`

  return { value, percent: value }
}

function updateFoulsForPenaltyConfirmed (event) {
  const { getCurrentPeriod } = this
  const { EventCode, TeamNumber, GamePeriod, RelatedEventNumber } = event
  const relatedEvent = this.getRelatedEvent(RelatedEventNumber)
  const { EventCode: relatedEventCode, TeamNumber: relatedTeamNumber } = relatedEvent || {}

  if (!(EventCode === 'PENALTY_CONFIRMED' || relatedEventCode === 'PENALTY_CONFIRMED')) {
    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'FOUL',
    period: GamePeriod || getCurrentPeriod,
    team: (relatedTeamNumber || TeamNumber) === 1 ? 'away' : 'home',
    type: EventCode === 'PENALTY_CONFIRMED' ? 'increment' : 'decrement'
  })
}

function updateFunction ({ period, team, type, value }) {
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period,
    team,
    type,
    value
  })

  if (prevZone !== 'defense') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: `possession_${prevZone}`,
      period,
      team,
      type,
      value
    })
  }
}

function adjustStatistic (event) {
  const { getCurrentPeriod, updateStatistic } = this
  const { EventCode, extra } = event
  const { count, count_1, count_2, period } = extra

  if ([
    'ADJUST_RED_CARD',
    'ADJUST_YELLOW_CARD',
    'ADJUST_THROW_IN',
    'ADJUST_SHOOT_GOALPOST',
    'ADJUST_GOAL_MOUTH_SHOT',
    'ADJUST_OFFSIDE',
    'ADJUST_CORNER_KICK',
    'ADJUST_MEDICAL_CREW',
    'ADJUST_FOUL',
    'ADJUST_GOAL_KICK'
  ].includes(EventCode)) {
    const properties = {
      'ADJUST_RED_CARD': 'RED_CARD',
      'ADJUST_YELLOW_CARD': 'YELLOW_CARD',
      'ADJUST_THROW_IN': 'THROW_IN',
      'ADJUST_SHOOT_GOALPOST': 'SHOOT_GOALPOST',
      'ADJUST_GOAL_MOUTH_SHOT': 'GOAL_MOUTH_SHOT',
      'ADJUST_OFFSIDE': 'OFFSIDE',
      'ADJUST_CORNER_KICK': 'CORNER_KICK',
      'ADJUST_MEDICAL_CREW': 'MEDICAL_CREW',
      'ADJUST_FOUL': 'FOUL',
      'ADJUST_GOAL_KICK': 'ZONE_GOAL_KICK'
    }

    const newStatistic = {
      statisticType: 'defaultStatistic',
      property: properties[EventCode],
      period: period || getCurrentPeriod,
      value: count,
      key: 'commonValue'
    }

    if (EventCode === 'ADJUST_MEDICAL_CREW') {
      updateStatistic(newStatistic)
    } else {
      newStatistic.value = count_1
      newStatistic.key = 'home'
      updateStatistic(newStatistic)

      newStatistic.value = count_2
      newStatistic.key = 'away'
      updateStatistic(newStatistic)
    }
  }
}

function getCommonPossessionStatistic (event) {
  const updateStatistic = updateFunction.bind(this)
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]

  if (!getActiveSide && !previousActiveSide) return

  if (EventCode === 'START_PERIOD' || overriddenType === 'shootout') {
    previousPlayTime = Playtime

    return
  }

  if (EventCode === 'STOP_GAME_CLOCK') {
    updateStatistic({
      type: 'increment',
      period: GamePeriod || getCurrentPeriod,
      team: previousActiveSide,
      value: Playtime - previousPlayTime
    })
  }

  if (isTimerStoped) {
    previousPlayTime = Playtime

    return
  }

  if (previousActiveSide !== getActiveSide) {
    if (previousActiveSide) {
      updateStatistic({
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    previousActiveSide = getActiveSide
    previousPlayTime = Playtime

    return
  }

  updateStatistic({
    period: GamePeriod || getCurrentPeriod,
    team: getActiveSide,
    type: 'increment',
    value: Playtime - previousPlayTime
  })

  previousPlayTime = Playtime
}
